var map = {
	"./global/actions.js": 575,
	"./global/getters.js": 2155,
	"./global/mutations.js": 5720,
	"./global/state.js": 3830,
	"./platform/actions.js": 39,
	"./platform/getters.js": 1487,
	"./platform/mutations.js": 8508,
	"./platform/state.js": 7559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6520;